import { ROUTES } from '@/constants/routes';

export const isCurrentPage = (href: string, asPath: string) =>
  (href === ROUTES.home && asPath === ROUTES.home) ||
  (href !== ROUTES.home && asPath.includes(href));
